import React, { useEffect, useMemo, useState } from "react";
import { popsApi } from "../lib/api";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "../components/ui/tabs";
import InvoicesTab from "../components/partnerops/InvoicesTab";
import RebillingTab from "../components/partnerops/RebillingTab";
import CspTab from "../components/partnerops/CspTab";
import ReportBuilderTab from "../components/partnerops/ReportBuilderTab";
import MarginTab from "../components/partnerops/MarginTab";
import HierarchyTab from "../components/partnerops/HierarchyTab";
import RestatementsTab from "../components/partnerops/RestatementsTab";
import CloseCopilotTab from "../components/partnerops/CloseCopilotTab";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../components/ui/select";

export function lastMonths(n = 6) {
  const out = [];
  const d = new Date();
  for (let i = 0; i < n; i++) {
    out.push(`${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`);
    d.setMonth(d.getMonth() - 1);
  }
  return out;
}

export default function PartnerOps() {
  const [config, setConfig] = useState(null);
  const [period, setPeriod] = useState(lastMonths(1)[0]);
  const periods = useMemo(() => lastMonths(6), []);

  const reload = () => popsApi.bootstrap().then(setConfig).catch(console.error);
  useEffect(() => { reload(); }, []);

  if (!config) {
    return <div className="px-6 lg:px-10 py-8 text-muted-foreground">Loading PartnerOps…</div>;
  }

  return (
    <div className="px-6 lg:px-10 py-8" data-testid="partnerops-page">
      <Tabs defaultValue="invoices">
        <div className="flex flex-wrap items-center gap-3 mb-6">
          <TabsList className="bg-white border border-border rounded-sm p-1 h-auto flex-wrap">
            {[
              { v: "invoices", l: "Invoices" },
              { v: "close", l: "Close Copilot" },
              { v: "restatements", l: "Restatements" },
              { v: "rebilling", l: "Customers & Rebilling" },
              { v: "csp", l: "CSP & Marketplace" },
              { v: "reports", l: "Report Builder" },
              { v: "margin", l: "Margin & Leakage" },
              { v: "hierarchy", l: "Hierarchy (L1/L2)" },
            ].map((t) => (
              <TabsTrigger
                key={t.v} value={t.v} data-testid={`pops-tab-${t.v}`}
                className="rounded-sm data-[state=active]:bg-[#00579e] data-[state=active]:text-white text-xs px-3 py-1.5"
              >
                {t.l}
              </TabsTrigger>
            ))}
          </TabsList>
          <div className="ml-auto flex items-center gap-2">
            <span className="text-[10px] uppercase tracking-[0.14em] text-muted-foreground">Billing period</span>
            <Select value={period} onValueChange={setPeriod}>
              <SelectTrigger className="rounded-sm h-8 text-xs w-[120px] cs-mono" data-testid="pops-period-select">
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                {periods.map((p) => <SelectItem key={p} value={p}>{p}</SelectItem>)}
              </SelectContent>
            </Select>
          </div>
        </div>

        <TabsContent value="invoices"><InvoicesTab period={period} config={config} onConfigChange={reload} /></TabsContent>
        <TabsContent value="close"><CloseCopilotTab period={period} /></TabsContent>
        <TabsContent value="restatements"><RestatementsTab /></TabsContent>
        <TabsContent value="rebilling"><RebillingTab config={config} onChange={reload} /></TabsContent>
        <TabsContent value="csp"><CspTab config={config} onChange={reload} /></TabsContent>
        <TabsContent value="reports"><ReportBuilderTab /></TabsContent>
        <TabsContent value="margin"><MarginTab period={period} config={config} /></TabsContent>
        <TabsContent value="hierarchy"><HierarchyTab period={period} /></TabsContent>
      </Tabs>
    </div>
  );
}
